import { Redirect, useLocation } from 'react-router-dom';
import DatePicker from 'react-date-picker';
import useJobLogs from '../../hooks/useJobLogs';
import {
  Button,
  Grid,
  GridColumn,
  Segment,
  Statistic,
  StatisticGroup,
  StatisticLabel,
  StatisticValue,
  Table,
} from 'semantic-ui-react';
import Filters from '../Common/Filters';
import { useState } from 'react';

import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import { format } from 'date-fns';
import { getLink, getLocalTime, timestampColumns } from '../../utils';
import { useSelector } from 'react-redux';

const columnsToShow = [
  'ExecutionId',
  'TaskName',
  'ClientName',
  'Statuses',
  'Status',
  'Duration',
  'createdAt',
];

const JobLogs = ({ clientId }: { clientId?: string }) => {
  const timezone = useSelector((state: any) => state.auth.timezone);
  const useLocalTime = timezone === 'UTC' ? false : true;

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const date = queryParams.get('date') || format(new Date(), 'yyyy-MM-dd');
  const clientIdParams = queryParams.get('clientId');

  const { logs, loading } = useJobLogs(clientId || clientIdParams, date);
  const [filteredLogs, setFilteredLogs] = useState(logs || []);
  const [shouldRedirect, setShouldRedirect] = useState(null);

  if (!loading || loading === 'loading') {
    return <div>Loading...</div>;
  }

  const handleDateChange = (newDate) => {
    debugger;
    if (date !== format(newDate, 'yyyy-MM-dd'))
      setShouldRedirect(format(newDate, 'yyyy-MM-dd'));
  };

  if (shouldRedirect && date !== shouldRedirect) {
    queryParams.set('date', shouldRedirect);
    queryParams.toString();
    return <Redirect to={`${location.pathname}?${queryParams.toString()}`} />;
  }

  return (
    <Segment>
      <div>
        Select Date:{' '}
        <DatePicker
          onChange={handleDateChange}
          value={new Date(date) || new Date()}
          locale="en-US"
          format="yyyy-MM-dd"
        />
      </div>

      {loading === 'failed' && <div>Failed to load job logs.</div>}
      {!logs || logs.length === 0 ? (
        <div>No logs found.</div>
      ) : (
        <div>
          <Grid columns={2} divided centered verticalAlign="middle">
            <GridColumn textAlign="center">
              <Filters
                originalList={logs}
                filteredLists={filteredLogs}
                allowedParams={[
                  'ClientName',
                  'ClientId',
                  'TaskName',
                  'id',
                  'Status',
                ]}
                setFilteredLists={setFilteredLogs}
              />
            </GridColumn>
            <GridColumn textAlign="center">
              <StatisticGroup>
                <Statistic>
                  <StatisticValue>{logs.length}</StatisticValue>
                  <StatisticLabel>Executed Jobs</StatisticLabel>
                </Statistic>
                <Statistic>
                  <StatisticValue>
                    {logs.filter((log) => log.Status === 'SUCCESS').length}
                  </StatisticValue>
                  <StatisticLabel>Success</StatisticLabel>
                </Statistic>
                <Statistic>
                  <StatisticValue>
                    {logs.filter((log) => log.Status === 'FAILED').length}
                  </StatisticValue>
                  <StatisticLabel>Failed</StatisticLabel>
                </Statistic>
                <Statistic>
                  <StatisticValue>
                    {logs.filter((log) => log.Status === 'IN PROGRESS').length}
                  </StatisticValue>
                  <StatisticLabel>In Progress</StatisticLabel>
                </Statistic>
              </StatisticGroup>
            </GridColumn>
          </Grid>

          <Table>
            <Table.Header>
              <Table.Row>
                {columnsToShow.concat('Actions').map((header) => {
                  return (
                    <Table.HeaderCell key={header}>{header}</Table.HeaderCell>
                  );
                })}
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {filteredLogs.map((log: any) => {
                return (
                  <Table.Row key={log.id}>
                    {columnsToShow
                      .map((elem: any) => {
                        return (
                          <Table.Cell key={`${elem}|${log.id}`}>
                            {elem === 'Statuses' ? (
                              <>
                                {Object.entries(log[elem]).map(
                                  ([key, value]) => {
                                    return (
                                      <p key={`${key}|${log.id}`}>
                                        {key} -{' '}
                                        {useLocalTime
                                          ? getLocalTime(value)
                                          : value}
                                      </p>
                                    );
                                  }
                                )}
                              </>
                            ) : timestampColumns.includes(elem) &&
                              useLocalTime ? (
                              getLocalTime(log[elem])
                            ) : log[elem] === false ? (
                              'false'
                            ) : (
                              log[elem] && log[elem].toString()
                            )}
                          </Table.Cell>
                        );
                      })
                      .concat(
                        <Table.Cell key={`${log.ScheduledTaskId}-actions`}>
                          <Table.Cell>
                            <a
                              href={getLink(log.ExecutionId, log.createdAt)}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <Button>View Logs</Button>
                            </a>
                          </Table.Cell>
                        </Table.Cell>
                      )}
                  </Table.Row>
                );
              })}
            </Table.Body>
          </Table>
        </div>
      )}
    </Segment>
  );
};

export default JobLogs;
